import { useEffect, useState } from "react";
import { saveDraft } from "./offline";

export const useConnectivity = () => {
  const [online, setOnline] = useState(navigator.onLine);
  useEffect(() => { const update = () => setOnline(navigator.onLine); window.addEventListener("online", update); window.addEventListener("offline", update); return () => { window.removeEventListener("online", update); window.removeEventListener("offline", update); }; }, []);
  return online;
};
export const useDraftStorage = (scope, form, orderId, dirty) => {
  const [state, setState] = useState("");
  useEffect(() => {
    if (!dirty.current) return;
    let active = true;
    setState("bewaren");
    saveDraft(scope, form, orderId).then(() => { if (active) setState("bewaard"); }).catch(() => { if (active) setState("fout"); });
    return () => { active = false; };
  }, [scope, form, orderId, dirty]);
  return state;
};